/**
 * 门店多值字段的展示文本。
 *
 * 后端把 storeNames 与 storeIds **同序**返回，查不到的门店用 null 占位（避免下标错位），
 * 所以这里严格按下标取名字；null/缺失时回退到本地门店表，再回退到门店 ID，保证不显示空。
 */
export function formatStoreNames(
  ids: string[],
  storeNames?: (string | null)[] | null,
  fallbackNames?: Map<string, string> | null,
): string {
  if (!ids.length) return '全部门店'
  return ids.map((id, index) => storeNames?.[index] || fallbackNames?.get(id) || id).join('、')
}
